import { Controller } from "@hotwired/stimulus"

// Shows/hides a panel based on a controlling checkbox — e.g. Settings →
// Facility page, where the gate-hours fields only appear when "24-hour access"
// is unchecked. The server renders the correct initial state; without JS the
// panel stays as rendered and the form still posts fine (progressive
// enhancement).
export default class extends Controller {
  static targets = ["checkbox", "panel"]
  static values = { showWhenChecked: { type: Boolean, default: false } }

  connect() {
    this.refresh()
  }

  refresh() {
    const checked = this.checkboxTarget.checked
    const show = this.showWhenCheckedValue ? checked : !checked
    this.panelTarget.classList.toggle("hidden", !show)
  }
}
